import React from 'react'
import { HelpContent } from "./HelpContent"
import { CommonSvgContent } from "./CommonSvgContent"



export const Help = (props) => {

    return(
      <div>
        <div className="underlay" onClick={() => props.onNextHelp()}></div>

        <div className="balloon help">

          <button className="close" onClick={() => props.onNextHelp()}>
            <CommonSvgContent stringToRet="ics" />
          </button>

          <HelpContent stringToRet={`${props.clickon}_room${props.room}`} />

        </div>
      </div>
    )
}
